import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

const AuthCallbackPage = () => {
  const { user } = useAuth();

  useEffect(() => {
    let cancelled = false;

    const syncSessionToIframe = async () => {
      for (let attempt = 0; attempt < 12 && !cancelled; attempt += 1) {
        const { data } = await supabase.auth.getSession();
        const session = data.session;

        if (session?.access_token && session.refresh_token) {
          if (window.opener && !window.opener.closed) {
            window.opener.postMessage(
              {
                type: 'caldeira-auth-session',
                access_token: session.access_token,
                refresh_token: session.refresh_token,
              },
              window.location.origin
            );
          }

          break;
        }

        await new Promise((resolve) => setTimeout(resolve, 500));
      }

      if (!cancelled && window.opener && !window.opener.closed) {
        window.close();
      }
    };

    void syncSessionToIframe();

    return () => {
      cancelled = true;
    };
  }, []);

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary">
      <p className="text-sm text-tertiary">Finalizando login...</p>
    </div>
  );
};

export default AuthCallbackPage;
